import {call, put} from "redux-saga/effects";
import {
  changeNurseStatus,
  getNurseUser,
  createNurseUser
} from "../requests/nurseService";
import {
  setLoading,
  setSuccess,
  getNurse,
  setNurse,
  setUpdatedNurse,
  setChangeStatus,
  createNurse,
  setError,
  setUpdateNurseIndex
} from "../../slices/nurseSlice";
import {toast} from "react-toastify";

export function* handleGetNurse(action) {

  try {
    yield put(setLoading(true))
    const response = yield call(() => getNurseUser(action.payload))
    yield put(setNurse(response.data))

  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    yield put(setError(errMsg))
  }
}

export function* handleCreateNurse(action) {

  try {
    yield put(setLoading(true))
    const response = yield call(() => createNurseUser(action.payload))
    yield put(setUpdatedNurse(response.data))
    toast.success(`Successfully registered`)
    yield put(setSuccess(true))
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    yield put(setError(errMsg))
    toast.error(errMsg)
  }
}

export function* handleChangeNurseStatus(action) {
  const query = action.payload
  try {
    // yield put(setLoading(true))
    const response = yield call(() => changeNurseStatus(query))
    yield put(setUpdateNurseIndex({
      index: action.payload.index,
      data: response.data,
    }))
    toast.success(`Successfully status changed`)
    yield put(setSuccess())
  } catch (error) {
    toast.error(error.message)
  }
}
